import React, { useEffect, useState } from "react";
import { Form, InputGroup, Table, Badge, Button } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import SplitPane from "react-split-pane";
import UseToggle from "../../../Hooks/UseToggle";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../Pagination";
import { FaLock } from "react-icons/fa";
import { useParams } from "react-router";
import EnvelopeDetails from "./EnvelopeDetails";

const EnvelopeView = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const [subjectList, setSubjectList] = useState([]);
  const [subjectCount, setSubjectCount] = useState(0);
  const [subjectData, setSubjectData] = useState("");
  const [searchData, setSearchData] = useState("");
  const [loading, setLoading] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(
    localStorage.getItem("studyPermissionData"),
  );

  const toggles = UseToggle();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectCount / itemsPerPage);

  const getStudySiteSubjectData = async (e) => {
    setLoading(true);
    let data = await studySubjectManagementServices.getStudySiteSubjectData(
      studyId,
      "eiwrs",
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage,
    );
    setSubjectList(data?.data || []);
    setSubjectCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    getStudySiteSubjectData();
  }, [subjectData, pageNumber, itemsPerPage]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-2">
          <div className="position-relative">
            <CiSearch
              className="position-absolute"
              style={{
                left: 10,
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6c757d",
              }}
            />
            <Form.Control
              placeholder="Search subject, rand no., site..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="ps-5"
              style={{ width: 300 }}
            />
          </div>
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={20}
        style={{ height: "calc(100vh - 182px)"}}
        className="position-relative"
        defaultSize={"100%"}
      >
        {loading ? (
          <PageLoader />
        ) : subjectCount === 0 ? (
          <NoDataFoundTable MSG={"Study Subject not found!"} />
        ) : subjectList?.length === 0 ? (
          <NoDataFoundTable MSG={"Search Study Subject not found!"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>
                    Total Assigned Kit
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Status</th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 5)}
                    style={{ width: 60 }}
                    className="text-center"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {subjectList?.map((subjectData, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    <td>{subjectData?.siteName}</td>
                    <td>{subjectData?.row?.SUBJECTID}</td>
                    <td>{subjectData?.totalKit}</td>
                    <td
                      className={`fw-bold text-capitalize ${subjectData?.subjectStatus === "discontinue" ? "text-danger" : subjectData?.subjectStatus === "ongoing" ? "text-warning" : "text-success"}`}
                    >
                      {subjectData?.subjectStatus}
                    </td>
                    <td className="text-center">
                      <button 
                        className="updateProfile"
                        style={{padding: "1px 10px"}}
                        onClick={() => {
                          setSubjectData(subjectData);
                          toggles.setToggle1();
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>

      <EnvelopeDetails
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Envelope Details"
        subjectData={subjectData}
      />
    </>
  );
};

export default EnvelopeView;
